const STATSIG_WINDOW_KEY = "__STATSIG__";
const STATSIG_USER_COHORT_KEY_PREFIX = "statsig@@";
export const statsigCohortParser = (window) => {
    try {
        if (!window[STATSIG_WINDOW_KEY]) {
            return;
        }
        const statsigWindowObject = window[STATSIG_WINDOW_KEY];
        if (!isStatsigWindowObject(statsigWindowObject)) {
            return;
        }
        const userCohorts = {};
        Object.values(statsigWindowObject.instances).forEach((instance) => {
            if (!instance._logger?._lastExposureTimeMap) {
                return;
            }
            Object.keys(instance._logger?._lastExposureTimeMap).forEach((lastExposureTimeKey) => {
                const experimentKey = parseStatsigExperimentKey(lastExposureTimeKey);
                if (!experimentKey) {
                    return;
                }
                const experiment = instance.getExperiment(experimentKey);
                if (isStatsigExperiment(experiment)) {
                    userCohorts[STATSIG_USER_COHORT_KEY_PREFIX + experiment.name] =
                        experiment.groupName;
                }
            });
        });
        return userCohorts;
    }
    catch (_) {
        return;
    }
};
const parseStatsigExperimentKey = (key) => {
    //example ["statsig::config_exposure|||funnel--signup--decouple_email_username_auth_steps|launchedGroup"]
    const parts = key.split("|");
    if (parts.length > 3) {
        return parts[3];
    }
    return undefined;
};
function isStatsigWindowObject(statsigWindowObject) {
    if (!statsigWindowObject || typeof statsigWindowObject !== "object") {
        return false;
    }
    if (!("instances" in statsigWindowObject) ||
        typeof statsigWindowObject.instances !== "object") {
        return false;
    }
    if (!statsigWindowObject.instances) {
        return false;
    }
    const instances = Object.values(statsigWindowObject.instances);
    for (const instance of instances) {
        if (!isStatsigInstance(instance)) {
            return false;
        }
    }
    return true;
}
function isStatsigInstance(instance) {
    if (!instance || typeof instance !== "object") {
        return false;
    }
    return ("_logger" in instance &&
        typeof instance._logger === "object" &&
        isStatsigLogger(instance._logger) &&
        "_sdkKey" in instance &&
        typeof instance._sdkKey === "string" &&
        "getExperiment" in instance &&
        typeof instance.getExperiment === "function");
}
function isStatsigLogger(logger) {
    if (!logger || typeof logger !== "object") {
        return false;
    }
    return ("_lastExposureTimeMap" in logger &&
        typeof logger._lastExposureTimeMap === "object");
}
function isStatsigExperiment(experiment) {
    if (!experiment || typeof experiment !== "object") {
        return false;
    }
    return ("name" in experiment &&
        typeof experiment.name === "string" &&
        "groupName" in experiment &&
        typeof experiment.groupName === "string");
}
